import script from "./AppIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=js"

import "./AppIcon.vue?vue&type=style&index=0&id=716034e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-716034e9"]])

export default __exports__